module.exports = __webpack_public_path__ + "img/pump-false.1b7d696f.png";